﻿import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.SessionServiceProxy
    ]
})
export class ServiceProxyModule { }
